module.exports = __webpack_public_path__ + "static/media/angle-double-down.b4517805.svg";